<script>
export default {
    props: {
        toggle: Boolean,
        title: String,
        method: Function,
    },
};
</script>

<template>
    <button
        :class="
            toggle === false
                ? 'toggle_button_180 button_unactive cursor_pointer_label mb_10 ml_10'
                : 'toggle_button_180 button_active cursor_pointer_label mb_10 ml_10'
        "
        @click="method"
        type="button"
    >
        <span class="toggle_indicator">{{ toggle ? '☑' : '☐' }}</span>
        <label>{{ title }}</label>
    </button>
</template>

<style scoped>
button {
    border-radius: 5px;
    box-shadow: none;

    margin-left: 10px;

    width: 180px;
    height: 26px;

    margin-bottom: 10px;

    color: #ffffff;
    border: 1px solid var(--left-separator);

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.toggle_indicator {
    font-size: 14px;
}

label {
    pointer-events: none;
}
</style>
